import { type EChartsExtensionInstallRegisters } from 'echarts';
import type ExtensionAPI from 'echarts/types/src/core/ExtensionAPI';

// 适用范围：xAxisLength = 1; yAxisLength <= 2; gridLength = 1;
function dvLocationHandle(chart: ExtensionAPI) {
  const option = chart.getOption();
  const xAxisOption = option.xAxis;
  const yAxisOption = option.yAxis;
  const gridOption = option.grid;

  if (
    !xAxisOption ||
    xAxisOption.length !== 1 ||
    !yAxisOption ||
    ![1, 2].includes(yAxisOption.length) ||
    !gridOption ||
    gridOption.length !== 1
  ) {
    return;
  }

  const gridRect = chart.getModel().getComponent('grid').coordinateSystem.getRect();
  yAxisOption.forEach((yAxisOptionItem, yAxisIndex) => {
    if (!yAxisOptionItem.dvNameLocation) {
      return;
    }

    const yNameLocation = {
      x: gridRect.x + (yAxisOptionItem.dvNameLocation === 'right' ? gridRect.width : 0),
      y: gridRect.y - yAxisOptionItem.nameGap
    };

    const yAxisModel = chart.getModel().getComponent('yAxis', yAxisIndex);
    const yAxisView = chart.getViewOfComponentModel(yAxisModel);

    const yAxisZr = yAxisView.group.childAt(0);
    const textZr = yAxisZr.childAt(0);
    const nameZr = textZr._children.find(d => d.anid === 'name');
    if (!nameZr) {
      return;
    }

    nameZr.stopAnimation();
    nameZr.attr({
      x: yNameLocation.x,
      y: yNameLocation.y,
      style: {
        align: yAxisOptionItem.dvNameLocation,
        verticalAlign: 'bottom'
      }
    });
  });
}

/**
 *
 * @param registers
 */
export function yAxisExtensionInstall(registers: EChartsExtensionInstallRegisters) {
  registers.registerUpdateLifecycle('afterupdate', (_, chart) => {
    dvLocationHandle(chart);
  });
}
